// Indian-style comma formatting for amount inputs (1,00,000)
export function formatINR(val) {
  if (val === "" || val == null) return "";
  const digits = String(val).replace(/[^\d]/g, "");
  if (!digits) return "";
  return parseInt(digits, 10).toLocaleString("en-IN");
}

// Strip commas / non-digits — keeps the raw string for state
export function parseINR(val) {
  return String(val ?? "").replace(/[^\d]/g, "");
}
